<div class="ord-page">

    <!-- Fejléc -->
    <div class="ord-head">
        <div class="ord-head__titles">
            <h1 class="ord-title">Rendelések</h1>
            <div class="ord-sub">Rendeléslista csomagolási és számla állapotokkal.</div>
        </div>
        <div class="ord-tabs">
            <button
                type="button"
                *ngFor="let tab of tabs"
                class="ord-tabs__btn"
                [class.is-active]="currentTab === tab"
                (click)="setTab(tab)"
            >{{tab}}</button>
        </div>
        <button type="button" class="ord-new-btn" (click)="openManual()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
            Új manuál rendelés
        </button>
    </div>

    <!-- Szűrősor -->
    <form class="ord-filters" [formGroup]="filterFormGroup">
        <div class="ord-search">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"></circle><line x1="16" y1="16" x2="21" y2="21"></line></svg>
            <input
                type="text"
                formControlName="customer"
                placeholder="Keresés rendelés ID / vevő / terméknév…"
                size="4"
                (afterValueChanged)="onFiltersChanged()"
            >
        </div>

        <div class="ord-date">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="1.8" stroke-linecap="round"><rect x="3" y="5" width="18" height="16" rx="2"></rect><line x1="3" y1="10" x2="21" y2="10"></line><line x1="8" y1="3" x2="8" y2="7"></line><line x1="16" y1="3" x2="16" y2="7"></line></svg>
            <input type="date" class="ord-date__input" [value]="dateInputValue('from')" (change)="onDateInput('from', $event)" aria-label="Kezdő dátum">
            <span class="ord-date__dash">–</span>
            <input type="date" class="ord-date__input" [value]="dateInputValue('to')" (change)="onDateInput('to', $event)" aria-label="Záró dátum">
        </div>

        <div class="ord-filter-chips">
        <div class="ord-shops">
            <button
                type="button"
                *ngFor="let shop of shopChips"
                class="ord-shop-chip"
                [class.is-active]="shopFilter === shop"
                (click)="setShopFilter(shop)"
            >
                <span class="ord-shop-chip__dot" *ngIf="shop !== 'Mind'" [style.background]="getShopDotColor(shop)"></span>
                {{shop}}
            </button>
        </div>

        <button
            type="button"
            class="ord-toggle"
            [class.is-active]="unpackedOnly"
            (click)="toggleUnpacked()"
        >Csak csomagolatlan</button>

        <button
            type="button"
            class="ord-toggle ord-toggle--today"
            [class.is-active]="todayOnly"
            (click)="toggleToday()"
        >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="12" height="9" rx="1.5"></rect><path d="M14 10 h4 l3 3 v3 h-7"></path><circle cx="7" cy="18.5" r="1.7"></circle><circle cx="17" cy="18.5" r="1.7"></circle></svg>
            Mai feladások
            <span class="ord-toggle__count ord-toggle__count--today" [class.is-active]="todayOnly">{{todayCount}}</span>
        </button>

        <button
            type="button"
            class="ord-toggle ord-toggle--late"
            [class.is-active]="lateOnly"
            (click)="toggleLate()"
        >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="13" r="8"></circle><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="13" x2="15" y2="15"></line><line x1="9" y1="2.5" x2="15" y2="2.5"></line></svg>
            Késői feladások
            <span class="ord-toggle__count ord-toggle__count--late">{{lateCount}}</span>
        </button>
        </div>
    </form>

    <!-- Táblázat -->
    <div class="ord-table" [class.ord-table--loading]="fetching">
        <div class="ord-grid ord-thead">
            <div class="ord-thead__cell">Shop</div>
            <div class="ord-thead__cell">Ügyfél</div>
            <div class="ord-thead__cell">ID</div>
            <div class="ord-thead__cell">Termék</div>
            <div class="ord-thead__cell">Idő</div>
            <div class="ord-thead__cell">Számla</div>
            <div class="ord-thead__cell">Címke</div>
            <div class="ord-thead__cell ord-thead__cell--center">Üzenet</div>
            <div></div>
            <div></div>
        </div>

        <div class="ord-grid ord-row" *ngFor="let r of visibleRows; trackBy: trackByOrderId" [ngClass]="r.stripClass">
            <div class="ord-cell-shop">
                <div class="ord-src" [ngClass]="r.badgeClass">{{r.srcInitial}}</div>
                <div class="ord-cell-shop__copy">
                    <div class="ord-cell-shop__name">{{r.shopName}}</div>
                    <div class="ord-cell-shop__country">{{r.country}}</div>
                </div>
            </div>

            <div class="ord-cell-customer">
                <div class="ord-cell-customer__row">
                    <div class="ord-cell-customer__name">{{r.name}}</div>
                    <span class="ord-custom-badge" *ngIf="r.custom" title="Egyedi rendelés">Egyedi</span>
                </div>
                <div class="ord-cell-customer__city">{{r.city}}</div>
            </div>

            <div class="ord-cell-id">
                <div class="ord-cell-id__id">{{r.idLabel}}</div>
                <div class="ord-cell-id__amt">{{r.amtLabel}}</div>
            </div>

            <div class="ord-cell-thumbs">
                <div class="ord-thumb" *ngFor="let th of r.thumbs; trackBy: trackByIndex" [title]="th.title">
                    <img *ngIf="th.imageFileName" class="ord-thumb__img" [appFetchComponentImage]="th.imageFileName" [alt]="th.title">
                    <div *ngIf="!th.imageFileName" class="ord-thumb__ph"></div>
                    <span class="ord-thumb__overlay" *ngIf="th.hasOverlay">{{th.overlay}}</span>
                </div>
            </div>

            <div class="ord-cell-days">
                <div class="ord-days" [ngClass]="r.daysClass" [title]="r.daysTitle">{{r.daysLabel}}</div>
            </div>

            <div class="ord-cell-inv">
                <button
                    type="button"
                    class="ord-chip"
                    data-label="Számla"
                    [class.ord-chip--on]="r.invOn"
                    [class.ord-chip--cancelled]="r.invCancelled"
                    (click)="openInvoice(r.order)"
                >{{r.invLabel}}</button>
            </div>

            <div class="ord-cell-lbl">
                <button
                    type="button"
                    class="ord-chip"
                    data-label="Címke"
                    [class.ord-chip--on]="r.lblOn"
                    [disabled]="isLabelActionLoading(r.order)"
                    (click)="openLabel(r.order)"
                >{{isLabelActionLoading(r.order) ? 'Folyamatban' : r.lblLabel}}</button>
            </div>

            <div class="ord-cell-msgs">
                <div
                    *ngIf="r.lateLabelPending"
                    class="ord-msg-icon ord-msg-icon--yellow"
                    title="Címke létrehozva, az ügyfél már kapott trackinget — de a csomag még nincs feladva!"
                >
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8A6A28" stroke-width="2.2" stroke-linecap="round"><circle cx="12" cy="12" r="9"></circle><line x1="12" y1="7.5" x2="12" y2="12"></line><line x1="12" y1="12" x2="15.5" y2="14.5"></line></svg>
                </div>
                <div *ngIf="r.custMsg" class="ord-msg-icon ord-msg-icon--yellow" [title]="r.custMsg">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8A6A28" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12 a8 8 0 0 1 -8 8 H4 l2 -3 a8 8 0 1 1 15 -5 Z"></path></svg>
                </div>
                <div *ngIf="r.teamMsgs > 0" class="ord-msg-icon ord-msg-icon--team" [class.ord-msg-icon--unread]="r.unreadMsgs > 0"
                     [title]="r.unreadMsgs > 0 ? r.unreadMsgs + ' új üzenet · ' + r.teamLabel : r.teamLabel">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#5E7FA8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3 l4 4 L8 20 H4 v-4 Z"></path></svg>
                    <span class="ord-msg-icon__count">{{ r.unreadMsgs > 0 ? r.unreadMsgs : r.teamMsgs }}</span>
                </div>
                <span *ngIf="r.noMsgs" class="ord-cell-msgs__none">–</span>
            </div>

            <div class="ord-cell-pack">
                <a class="ord-pack-btn" [routerLink]="'/orders/' + r.order.id">Csomagolás</a>
            </div>

            <div class="ord-cell-arch">
                <button
                    type="button"
                    class="ord-archive-btn"
                    [title]="r.archived ? 'Visszaállítás aktívra' : 'Archiválás'"
                    (click)="toggleArchive(r)"
                >
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="4" rx="1"></rect><path d="M5 8 v11 a1 1 0 0 0 1 1 h12 a1 1 0 0 0 1 -1 V8"></path><line x1="10" y1="12" x2="14" y2="12"></line></svg>
                </button>
            </div>
        </div>

        <div class="ord-empty" *ngIf="!fetching && visibleRows.length === 0">Nincs a szűrésnek megfelelő rendelés.</div>
    </div>

    <!-- Lábléc + lapozás -->
    <div class="ord-foot">
        <div class="ord-foot__label">{{footerLabel}}</div>
        <div class="ord-pager" *ngIf="totalOrders > 0">
            <select class="ord-pager__size" [value]="pageSize" (change)="setPageSize($any($event.target).value)" aria-label="Oldalméret">
                <option *ngFor="let size of pageSizeOptions" [value]="size" [selected]="size === pageSize">{{size}} / oldal</option>
            </select>
            <button type="button" class="ord-pager__btn" [disabled]="pageIndex === 0" (click)="goToPage(pageIndex - 1)" aria-label="Előző oldal">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="14,6 8,12 14,18"></polyline></svg>
            </button>
            <span class="ord-pager__info">{{pageRangeLabel}}</span>
            <button type="button" class="ord-pager__btn" [disabled]="isLastPage" (click)="goToPage(pageIndex + 1)" aria-label="Következő oldal">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="10,6 16,12 10,18"></polyline></svg>
            </button>
        </div>
    </div>

    <!-- Manuál rendelés modal -->
    <div class="ord-modal-overlay" *ngIf="manualOpen">
        <div class="ord-modal">
            <div class="ord-modal__head">
                <h2 class="ord-modal__title">Új manuál rendelés</h2>
                <button type="button" class="ord-modal__close" title="Bezárás" (click)="closeManual()">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
                </button>
            </div>
            <p class="ord-modal__sub">Egyedi rendelés kézzel — létrehozás után a rendeléslistába kerül, a doboz és a súly ott adható meg feladáskor.</p>

            <!-- Számlázási cím -->
            <div class="ord-modal-card">
                <div class="ord-modal-card__head">
                    <div class="ord-modal-card__kicker">Számlázási cím</div>
                    <div class="ord-type-chips">
                        <button
                            type="button"
                            class="ord-type-chip"
                            [class.is-active]="manual.type === 'Magán'"
                            (click)="setManualType('Magán')"
                        >Magán</button>
                        <button
                            type="button"
                            class="ord-type-chip"
                            [class.is-active]="manual.type === 'Céges'"
                            (click)="setManualType('Céges')"
                        >Céges</button>
                    </div>
                </div>
                <div class="ord-modal-grid">
                    <div *ngFor="let f of manualBillFields; trackBy: trackByFieldKey" [class.ord-modal-grid__full]="f.full">
                        <div class="ord-field-label">{{f.label}}</div>
                        <input
                            class="ord-field-input"
                            [placeholder]="f.ph"
                            [ngModel]="manual[f.key]"
                            (ngModelChange)="manual[f.key] = $event"
                            [ngModelOptions]="{standalone: true}"
                        >
                    </div>
                </div>
            </div>

            <!-- Szállítási cím -->
            <div class="ord-modal-card">
                <div class="ord-modal-card__head ord-modal-card__head--tight">
                    <div class="ord-modal-card__kicker">Szállítási cím</div>
                    <div class="ord-ship-same" (click)="toggleManualShipSame()">
                        <span class="ord-ship-same__box" [class.is-checked]="manual.shipSame">
                            <svg *ngIf="manual.shipSame" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="5,12.5 10,17.5 19,7.5"></polyline></svg>
                        </span>
                        <span class="ord-ship-same__label">Megegyezik a számlázási címmel</span>
                    </div>
                </div>
                <div class="ord-modal-grid ord-modal-grid--ship" *ngIf="!manual.shipSame">
                    <div *ngFor="let f of manualShipFields; trackBy: trackByFieldKey" [class.ord-modal-grid__full]="f.full">
                        <div class="ord-field-label">{{f.label}}</div>
                        <input
                            class="ord-field-input"
                            [ngModel]="manual[f.key]"
                            (ngModelChange)="manual[f.key] = $event"
                            [ngModelOptions]="{standalone: true}"
                        >
                    </div>
                </div>
            </div>

            <!-- Termékek -->
            <div class="ord-modal-card">
                <div class="ord-modal-card__kicker ord-modal-card__kicker--spaced">Termékek</div>
                <div class="ord-prod-search">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="2" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"></circle><line x1="15.5" y1="15.5" x2="20" y2="20"></line></svg>
                    <input [formControl]="manualSearchCtrl" placeholder="Termék keresése név vagy SKU alapján…">
                </div>
                <div class="ord-prod-results" *ngIf="manualResults.length > 0">
                    <div class="ord-prod-result" *ngFor="let p of manualResults">
                        <div class="ord-prod-result__copy">
                            <div class="ord-prod-result__name">{{p.name}}</div>
                            <div class="ord-prod-result__meta">{{p.meta}}</div>
                        </div>
                        <button type="button" class="ord-prod-result__add" (click)="addManualItem(p)">Hozzáadás</button>
                    </div>
                </div>
                <div class="ord-prod-empty" *ngIf="manual.items.length === 0">Még nincs termék a rendelésben — keress rá fent.</div>
                <div class="ord-prod-items" *ngIf="manual.items.length > 0">
                    <div class="ord-prod-item" *ngFor="let it of manual.items; let i = index; trackBy: trackByIndex">
                        <div class="ord-prod-item__name">{{it.name}}</div>
                        <div class="ord-prod-item__qty">
                            <span class="ord-prod-item__unit">db</span>
                            <input type="number" min="1" [value]="it.qty" (input)="setManualQty(i, $any($event.target).value)">
                        </div>
                        <div class="ord-prod-item__price">
                            <input type="number" min="0" step="0.5" [value]="it.price" (input)="setManualPrice(i, $any($event.target).value)" placeholder="Ár">
                            <span class="ord-prod-item__unit">EUR/db</span>
                        </div>
                        <div class="ord-prod-item__sum">{{manualLineSum(it)}}</div>
                        <button type="button" class="ord-prod-item__remove" title="Eltávolítás" (click)="removeManualItem(i)">
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
                        </button>
                    </div>
                    <div class="ord-prod-total">
                        <span class="ord-prod-total__label">Összesen:</span>
                        <span>{{manualTotal}}</span>
                    </div>
                </div>
            </div>

            <!-- Határidő + kiküldés -->
            <div class="ord-modal-card ord-modal-card--last">
                <div class="ord-modal-card__kicker ord-modal-card__kicker--deadline">Feladási határidő</div>
                <div class="ord-deadline-chips">
                    <button
                        type="button"
                        *ngFor="let d of manualDeadlines"
                        class="ord-deadline-chip"
                        [class.is-active]="manual.deadline === d"
                        (click)="setManualDeadline(d)"
                    >{{d}} nap</button>
                </div>
                <div class="ord-deadline-info">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"></circle><line x1="12" y1="10.5" x2="12" y2="16.5"></line><circle cx="12" cy="7.6" r="0.4" fill="currentColor"></circle></svg>
                    Várható kiküldési költség: ~4,20–5,60 EUR dobozmérettől függően. A pontos dobozt és súlyt a rendelés részleteinél adod meg feladáskor.
                </div>
            </div>

            <div class="ord-modal__actions">
                <button type="button" class="ord-modal__cancel" (click)="closeManual()">Mégse</button>
                <button
                    type="button"
                    class="ord-modal__create"
                    [class.is-disabled]="!manualCanCreate || manualCreating"
                    (click)="createManualOrder()"
                >Rendelés létrehozása</button>
            </div>
        </div>
    </div>

</div>
